import { Button as MuiButton, ButtonProps as MuiButtonProps, styled } from "@mui/material";

import { colors } from "../../utils/brand-colors";

const StyledButton = styled(MuiButton)(({ theme }) => {
  return {
    border: `1px solid ${colors.dropdownBorder}`,
    borderRadius: "6px",
    padding: "4px 10px",
    textTransform: "none",
    height: "24px",
    fontSize: "14px",
    fontWeight: 400,
    color: theme.palette.mode === "light" ? colors.black : colors.white,
  };
});

interface DropdownButtonProps extends MuiButtonProps {
  children: React.ReactNode;
}

export const DropdownButton: React.FC<DropdownButtonProps> = ({ children, ...props }) => {
  return <StyledButton {...props}>{children}</StyledButton>;
};

export default DropdownButton;
